import { ReactNode } from 'react';

import { fontStyles } from '@/styles/typography';

export const StyledH2 = ({ className, children }: { className?: string; children: ReactNode }) => (
  <h2
    className={fontStyles({
      variant: 'H2',
      className: `mb-4 grid ${className}`,
    })}
  >
    {children}
  </h2>
);

export const StyledParagraph = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <p
    className={fontStyles({
      variant: 'BODY_LG',
      className: `text-token-gray-800 ${className}`,
    })}
  >
    {children}
  </p>
);

export const StyledPrimaryCell = ({
  className,
  children,
  style,
}: {
  className?: string;
  children: ReactNode;
  style?: React.CSSProperties;
}) => (
  <section
    className={`border-token-gray-300 tablet:pt-15 tablet:px-15 bg-token-gray-100 mx-auto mb-5 flex w-full max-w-[1240px] overflow-hidden rounded-md border border-solid px-11 pt-11 ${className}`}
    style={style}
  >
    {children}
  </section>
);

export const StyledSecondaryCell = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => (
  <div
    className={`bg-primitive-alphadark-100 border-token-gray-400 rounded-t-[1.25rem] border border-b-0 shadow-[0px_1.7px_3.4px_0px_rgba(0,0,0,0.02),0px_17.1px_60px_0px_rgba(0,0,0,0.06),0px_1.7px_10.3px_0px_rgba(0,0,0,0.03)] ${className}`}
  >
    {children}
  </div>
);
